const daysToMonths = (days = 0) => days / (365.25 / 12)

export default daysToMonths
